import React from 'react';
import { Link } from 'react-router-dom';

import Button from 'xpi-black-ui/Base/Button';
import { P } from 'xpi-black-ui/Base/Typography';
import Dialog, { DialogHeader } from 'xpi-black-ui/Common/Dialog';

import PageView from 'components/Common/PageView';
import waConfig from 'utils/waConfig';

import { DialogContent, DialogMsgs } from './styles';

import { Props, DefaultProps } from './shape';

const SendProposalsSuccess = ({ onClose, msgsError, ...otherProps }) => (
  <Dialog {...otherProps} overlayClick={onClose}>
    <PageView page={waConfig.pageview.acquisitionSuccess} />
    <DialogHeader title="Proposta enviada ao cliente" onClose={onClose} />
    <DialogContent>
      <>
        <DialogMsgs>
          <p>Assessor, seu cliente receberá um push com a proposta da operação, ela deve ser aceita hoje. Caso ele não aceite, esta operação será rejeitada.</p>
          {
            msgsError.length > 0
            && msgsError.map(msg => (
              <P bold className="warning" id={msg.descricao}>{msg.descricao}</P>
            ))
          }
        </DialogMsgs>
        <Link to="/central-de-propostas">
          <Button secondary>Ir Para Central de Propostas</Button>
        </Link>
        <Link to="/operacoes">
          <Button>Ver operações disponíveis</Button>
        </Link>
      </>
    </DialogContent>
  </Dialog>
);

SendProposalsSuccess.propTyps = Props;
SendProposalsSuccess.defaultProps = DefaultProps;

export default SendProposalsSuccess;
